module.exports = __webpack_public_path__ + "static/img/client18_img.bae933b.png";